export default "__VITE_ASSET__6ed3ddd8__"